import { BaseObject, SafeBaseObject } from '@common/models/base-object.models';
import { DateTime } from 'luxon';
import { IReservationApiParametersBookCamp, IReservationApiParametersRoomConfHdr, IReservationApiParametersSuite } from './res-booking.model';

export class ReservationOptionCost extends SafeBaseObject {
  cost = 0;
  costIsNull = true
  currency = '';
  date = DateTime.invalid('empty');
  dateFrom = DateTime.invalid('empty');
  dateTo = DateTime.invalid('empty');
  dateCost = DateTime.invalid('empty');
  startDate = DateTime.invalid('empty');
  endDate = DateTime.invalid('empty');
  dateStart = DateTime.invalid('empty');
  dateEnd = DateTime.invalid('empty');
  optionCostPerDayID = 0;
  optionID = 0;
  optionName = '';
  serviceID = 0;
  supplierID = 0;
  hasBkg = false;
  isEstimated = false;

  agencyGroupCod = '';
  agencyGroupDesc = '';
  rateCode = '';
  priceSetupID = 0;
  bedType?: string;
  mealPlan?: string;
  costSource?: string;

  cityTax?: number;
  includeCityTax?: boolean;
  type?: string;
  priceSetupIDCS?: number;
  vat?: number;
  includeVAT?: boolean;
  serviceTax?: number;
  includeServiceTax?: boolean;
  serviceTaxType?: string;
  serviceTaxSetup?: number;

  hasCostBreakdown: boolean = false;
  priceTypeID?: number;
  priceTypeName?: string;

  get costDisplay() {
    if (this.costIsNull) return null
    return this.cost
  }
  constructor(data?: any) {
    super();
    if (data) {
      this.updateData(data);
      this.costIsNull = data.Cost === null;
      if (data?.VAT || data?.vat) this.vat = data.VAT ?? data.vat;
      if ((this.cityTax ?? 0) > 0 || (this.vat ?? 0) > 0 || (this.serviceTax ?? 0) > 0) this.hasCostBreakdown = true;
      this.includeCityTax = (data.IncludeCityTax == 'Y') || data.includeCityTax;
      this.includeVAT = (data.IncludeVAT == 'Y') || data.includeVAT;
      this.includeServiceTax = (data.IncludeServiceTax == 'Y') || data.includeServiceTax;
    }
  }

  get isEstimatedDisplay() {
    if (this.cost >= 0 && !this.isEstimated) return 'Real Cost';
    return 'Estimated Cost';
  }
}

export class ReservationOptionCostFilters extends SafeBaseObject {
  bedType?: string;
  bedTypeSort?: number;
  costSource?: string;
  isEstimated?: string;
  mealPlan?: string;
  costPriceType?: string;

  constructor(data?: any) {
    super();
    if (data) {
      this.updateData(data);
      if (data.PriceTypeID) this.costPriceType = data.PriceTypeID;
    }
  }
}

export class ReservationOptionPrice extends BaseObject {
  price: number;
  currency: string;
  date: DateTime;
  datePrice: DateTime;
  pricePerDateID: number;
  optionID: number;
  optionName: string;
  serviceID: number;
  priceTypeID: number
  margin: number;
  rOE: number;
  snglSuppCommPerc: number;
  snglSuppType: string;
  snglSuppValue: number;


  constructor(data: IReservationApiOptionPrice) {
    super();
    this.price = 0;
    this.currency = '';
    this.date = DateTime.min();
    this.datePrice = DateTime.min();
    this.pricePerDateID = 0;
    this.optionID = 0;
    this.optionName = '';
    this.serviceID = 0;
    this.priceTypeID = 0;
    this.margin = 0;
    this.rOE = 0;
    this.snglSuppCommPerc = 0;
    this.snglSuppType = '';
    this.snglSuppValue = 0;
    if (data) this.updateData(data);
  }

  override updateData(data: IReservationApiOptionPrice): void {
    this.addMangledProperty(data);
    this.addDateTimeProperty('date', data, 'Date');
    this.addDateTimeProperty('datePrice', data, 'DatePrice');
  }

  get marginPercentage(): string {
    return this.margin != null ? `${this.margin}%` : '';
  }
}

export interface IReservationApiOptionPrice {
  Price?: number;
  Currency?: string;
  Date?: DateTime;
  DatePrice?: DateTime;
  PricePerDateID?: number;
  OptionID?: number;
  OptionName?: string;
  ServiceID?: number;
  PriceTypeID?: number;
  ROE?: number;
  SnglSuppCommPerc?: number;
  SnglSuppType?: string;
  SnglSuppValue?: number;
}

export interface IReservationGetBkgServicesParams {
  BkgID?: number;
  SectionID?: number;
  ServiceTypeID?: number;
  SearchText?: string;
  SupplierID?: number,
  SupplierName?: string;
  OptionName?: string;
  DateFrom?: DateTime;
  DateTo?: DateTime;
  CountryCod?: string;
  CityID?: number;
  CitiesID?: string;
  MovingTypeID?: number;
  Amenities?: string
  Star?: string;
  ServiceID?: number;

  PageNum?: number
  PageSize?: number
  OrderBy?: string
  OrderByType?: 'ASC' | 'DESC'
}

export interface IServiceOptionGuest2Room {
  ServiceID: number
  OptionID: number
  RoomGUID: string
  GuestCod: string
  GroupID: number
}
export interface IReservationGetBkgOptionsParams {
  BkgID?: number;
  SectionID?: number;
  ServiceID?: number;
  SearchText?: string;
  DateFrom?: DateTime;
  DateTo?: DateTime;
  SupplierName?: string;
  OptionName?: string;
}
export interface IResBkgItemNewPriceType {
  ItemID: number
  PriceTypeID: number
}
export interface IResBkgItemChangePriceType {
  BkgID: number
  NewPriceType: IResBkgItemNewPriceType[]
}
export interface IReservationAddServiceOptionParams {
  BkgID?: number;
  VersionID?: number;
  PackageOptions?: IReservationAddServiceOptionPackageParams[];
  ServiceIncluded?: IReservationAddServiceOptionPackageParams[];
  LoyaltyRedemption?: IReservationAddServiceOptionLoyaltyRedemption[];
  Certificate?: IReservationAddServiceOptionCertificate[];
  GuestCod?: string;
  Alternative?: string;
  NewSuite?: IReservationApiParametersSuite[]
  BookCamp?: IReservationApiParametersBookCamp[]
  KeySuiteID?: number;
  RoomID?: number;
  SuiteNum?: string;
  NewPriceTypeID?: number
  WL?: string
  RoomConfHdr: IReservationApiParametersRoomConfHdr[]
  TMStartDate?: DateTime
  OptionIDFh?: number
}

export interface IReservationOptionManageParams {
  ServiceID: number
  OptionID: number
  ItineraryDate: DateTime
  GuestCod: number
}
export interface IReservationAddGuestToItemParams {
  BkgID: number
  items: IReservationOptionManageParams[]
}
export interface IReservationAddExtraOptionParams {
  BkgID: number;
  Extra: IReservationAddExtraOptionPackageParams[];
}
export interface IReservationAddServiceOptionLoyaltyRedemption {
  OptionCod?: string;
  IndividualID?: number;
  TierID?: number;
  Note?: string;
}

export interface IReservationAddServiceOptionCertificate {
  CertificateID: number;
  BkgID: number;
  GuestCod: string;
  Amount: number;
  CurrencyCod: string;
}

export interface IReservationEditServiceOptionParams {
  BkgID?: number;
  SectionID?: number;
  Items?: IReservationEditServiceOptionItem[];
}

export interface IReservationEditServiceOptionItem {
  ItemID?: number;
  ItineraryDate?: DateTime;
  SellingPrice?: string;
  Commissionable?: string;
  ForcedSupplierID?: number;
  TierID?: number;
}

export interface IReservationDeleteOptionPackageParams {
  BkgID?: number;
  GuestCod?: string;
  VersionID?: number;
  PackageOptions?: IReservationEditServiceOptionItem[];
}

export interface IResManageMultipleEditItem {
  BkgID: number
  EditItem: IResMultipleEditItem[];
}
export interface IResMultipleEditItem {
  ItemID: number;
  Sync: string;
  Insurance: string;
  Commissionable: string;
}
export interface IReservationDeleteServiceOptionItem {
  ServiceID?: number;
  OptionID?: number;
  ItineraryDate?: DateTime;
  GuestCod?: string;
}

export interface IReservationAddServiceOptionPackageParams {
  ServiceID?: number;
  OptionID?: number;
  VoyageID?: number
  PackageID?: number
  PackageTravelDateID?: number
  ItineraryDate?: DateTime;
  Price?: number;
  Markup?: number;
  SBCMessage?: string;
  Inclusive?: boolean;
  Quantity?: number;
  GuestTo?: string
  Alternative?: string
  BedType?: string;
  MealCod?: string;
  RoomID?: number;
  RoomGUID?: string;
  MarginCalculatorParameterID?: number;
  ExchangeRate?: number;
  Margin?: number;

  CostPriceTypeID?: number
  PriceTypeID?: number
}
export interface IReservationAddExtraOptionPackageParams {
  ServiceID: number;
  OptionID: number;
  ItineraryDate: DateTime;
  GuestCod: number
  Quantity?: number
}

export interface IReservationUpdateMessageParams {
  BkgID?: number;
  OptionID?: number;
  ItemID?: number;
  GuestCod?: string;
  SectionID?: number;
  Message?: string;
  FileGuid?: string;
  FileId?: number;
  FileName?: string;
  supplierRemark?: string;
  fileGuidSupRmk?: string;
  fileIdSupRmk?: number;
  fileNameSupRmk?: string;
}




export interface IReservationApiCloneServices {
  ServiceID: number
  ServiceLongName?: string
  ServiceShortName?: string
  CloneTC?: string
  CloneRules?: string
  CloneCommunications?: string
  CloneTag?: string
  CloneExtra?: string
  CloneAdditional?: string
}

export interface IReservationApiGetOptions {
  ServiceID?: number;
  OptionID?: number;
  MinPax?: number;
  MaxPax?: number;
  OptionName?: string;
  OptionShortName?: string;
  OptionDesc?: string;
  Commissionable?: string;
  Refundable?: string;
  IsSBC?: string;
  IsIncluded?: string;
  IsActive?: string;
}

export interface IReservationApiGetOptionCost {
  ServiceID?: number;
  OptionID?: number;
  Year?: number;
  DateFrom?: DateTime;
  DateTo?: DateTime;
  GridView?: string;
  BedType?: string;
  MealPlan?: string;
  AgencyGroupCod?: string;
  CostSource?: string;
  PriceTypeID?: string;
  IsEstimated?: string;
  IsForcedFilters?: 'Y' | 'N';
}


export interface IReservationApiManageV2OptionCost {
  ServiceID?: number;
  OptionID?: number;
  Year?: number;
  Currency?: string;
  BedType?: string;
  MealPlan?: string;
  CostSource?: string;
  CostSetup?: IReservationApiCostPriceSetup[]
  ToDel?: string;
  AgencyGroupCod?: string,
  RateCode?: string,
  PriceTypeID?: string,
}
export interface IReservationApiManageV2OptionPrice {
  ServiceID?: number;
  OptionID?: number;
  Year?: number;
  PriceTypesID?: string;
  PriceTypeID?: number;
  PriceSetup?: IReservationApiCostPriceSetup[];
  CurrencySetup?: IReservationCurrencySetup[];
  PriceSetupID?: number;
  CostPriceTypeID?: string;
  CurrencyCod?: string;
  BedType?: string;
  MealPlan?: string;
  CostSource?: string;
  AgencyGroupCod?: string,
}

export interface IReservationApiCostPriceSetup {
  PerDayID?: number;
  OptionID?: number;
  ServiceID?: number;
  DateStart?: string; // date per availability
  DateEnd?: string; // date per availability
  DateFrom?: DateTime; // date per cost
  DateTo?: DateTime; // date per cost
  Cost?: string | null;
  Currency?: string;
  PriceTypeID?: number;
  PriceSetUpID?: number;
  Margin?: string;
  ROE?: string;
  Price?: string;
  Status?: 'A' | 'D';
  SnglSuppCommPerc?: number;
  SnglSuppType?: string;
  SnglSuppValue?: number;
  StoPerc?: number;
  CityTax?: number;
  IncludeCityTax?: 'Y' | 'N';
  Type?: string;
  VAT?: number;
  IncludeVAT?: 'Y' | 'N';
  PriceSetupIDCS?: number;
  BedType?: string;
  MealPlan?: string;
  CostSource?: string;
  ServiceTax?: number;
  IncludeServiceTax?: 'Y' | 'N';
  ServiceTaxType?: string;
  ServiceTaxSetup?: number;
  OptionCostPerDayID?: number;
  CostPriceTypeID?: string,
  AgencyGroupCod?: string,
  RateCode?: string,
}

export interface IReservationCurrencySetup {
  Currency: string;
  Margin: number;
  ROE: number;
  FixedPrice: number;
}

export interface IReservationApiGetOptionPrice {
  ServiceID?: number;
  OptionID?: number;
  Year?: number;
  BedType?: string;
  MealPlan?: string;
  CostPriceTypeID?: number;
  CurrencyCod?: string;
  PriceTypeID?: number;
}
export interface IReservationSuiteType {
  VoyageID: number;
  SuiteNumber?: number | undefined;
  SuiteCategoryID?: number;
  SuiteCategoryCod?: string | undefined;
  SuiteCapacityID?: number;
  IsGty: string;
}

export interface IReservationCheckComboAvailabilityParams {
  BkgID?: number;
  VersionID?: number;
  NewSuite: Array<IReservationSuiteType>
}

export class ReservationOptionAvailability extends SafeBaseObject {
  availabilitybyOptionID = 0;
  date = DateTime.invalid('empty');
  dateAvl = DateTime.invalid('empty');
  propertyID = 0;
  optionID = 0;
  serviceID = 0;
  initialQTY = 0;
  onHoldQTY = 0;
  initialAllotmentQTY = 0;
  onHoldAllotmentQTY = 0;
  priceTypeID = 0;
  agencyID = 0;
  usedQuantity = 0;
  usedQuantityBySpl = 0;

  constructor(data: any) {
    super();
    if (data) this.updateData(data);
  }
}

export interface IReservationApiOptionAvailability {
  AvailabilitybyOptionID?: number;
  Date?: DateTime;
  PropertyID?: number;
  OptionID?: number;
  ServiceID?: number;
  InitialQTY?: number;
  OnHoldQTY?: number;
  InitialAllotmentQTY?: number;
  OnHoldAllotmentQTY?: number;
  PriceTypeID?: number;
  AgencyID?: number;
  Status?: 'A' | 'D';
  ERES_AllocationCode?: string;
  ERES_AgencyCod?: string;
  ERES_RateCode?: string;
}
export interface IReservationApiOptionAllocation {
  AllocationbyOptionID?: number;
  Date?: DateTime;
  PropertyID?: number;
  OptionID?: number;
  ServiceID?: number;
  InitialAllotmentQTY?: number;
  OnHoldAllotmentQTY?: number;
  Status?: string;
  PackageID?: number;
  PackageTravelDateID?: number
  Reason?: string;
  ERES_AllocationCode?: string;
  ERES_AgencyCod?: string;
  ERES_RateCode?: string;
}

export interface IReservationApiGetOptionAvailability {
  ServiceID?: number;
  OptionID?: number;
  Year?: number;
  GridView?: string;
}
export interface IReservationApiGetOptionAllocation {
  ServiceID?: number;
  OptionID?: number;
  Year?: number;
}
export interface IReservationApiGetAllocationByOption {
  ServiceID: number;
  OptionID: number;
  Year?: number;
  PackageID?: number;
  DateFrom?: DateTime;
  DateTo?: DateTime;
  OnlyPkg?: string;
  Daily?: string;
}
export interface IReservationApiGetAllocationByOptPkg {
  ServiceID: number;
  OptionID: number;
  Year: number;
  PackageID: number;
}
export interface IResApiPkgEResAllocation {
  PackageID: number
  PackageTravelDateID?: number
  ServiceTypeIDList?: number;
  ServiceIDList?: number
  OptionID?: number
  DateFrom?: DateTime,
  DateTo?: DateTime,
  TravelStartDate?: DateTime,
  DayList?: string,
  Code?: string,
  RateCode?: string,
  AgentCode?: string,
}

export interface IResApiPkgEResAllocationManageParams {
  allocationsEres: {
    date?: DateTime;
    packageID?: number;
    packageTravelDateID?: number;
    optionID?: number;
    serviceID?: number;
    allocationbyOptionID?: number;
    suiteCode?: string;
    rateCode?: string;
    agentCode?: string;
    allocation?: number;
    available?: number;
  }[]
}
export interface IReservationApiGetPriceDayByDay {
  ServiceID?: number;
  OptionID?: number;
  PriceTypeID?: number;
  CostPriceTypeID?: number;
  MealPlan?: string;
  BedType?: string;
  Currency?: string;
  Year?: number;
  Page?: number;
  PageSize?: number;
}

export interface IReservationApiGetCostPerPax {
  ServiceID?: number;
  OptionID?: number;
  Year?: number;
  Currency?: string;
  MealPlan?: string;
  BedType?: string;
  AgencyGroupCod?: string;
  PriceTypeID?: string;
}

export interface IReservationApiGetSgjCostPerPax {
  ServiceID?: number;
  OptionID?: number;
  PackageTypeID?: number;
  Currency?: string;
  Year?: number;
  MealPlan?: string;
  BedType?: string;
  AgencyGroupCod?: string;
  Page?: number;
  PageSize?: number;
}

export interface IReservationApiGetHolidayMarkup {
  ServiceID?: number;
  OptionID?: number;
  Year?: number;
  Currency?: string;
}

export interface IReservationApiGetCostPerDayChild {
  ServiceID?: number;
  OptionID?: number;
  Year?: number;
  Currency?: string;
  MealPlan?: string;
  BedType?: string;
  PriceTypeID?: number;
  AgencyGroupCod?: string;
}

export interface IReservationApiGetOptionAllocationDetails {
  ServiceID?: number;
  OptionID?: number;
  PackageID?: number;
  DateFrom?: DateTime;
  DateTo?: DateTime;
}

export interface IReservationApiManageOptionAvailability {
  Availabilities: IReservationApiOptionAvailability[],
  Allocations?: IReservationApiOptionAllocation[],
}
export interface IReservationApiManageOptionAllocation {
  Allocations: IReservationApiOptionAllocation[],
  AllChildDates?: string
}


export interface IResApiReplaceOptionsParams {
  Opt2Replace: IResApiReplaceOption[]
  ReplaceByDate: 'Y' | 'N';
}

export interface IResApiReplaceOption {
  BkgID: number;
  ServiceID_OLD: number;
  OptionID_OLD: number;
  ServiceID_NEW: number;
  OptionID_NEW: number;
  ManageAvail: boolean;
  ItineraryDate?: DateTime;
  ItemListID?: string;
}

export interface IResApiReplaceAvailability {
  IsAvl: number;
  BkgID: number;
  ServiceID_OLD: number;
  OptionID_OLD: number;
  Allocation: number;
  Availability: number;
}

export interface IResApiReplaceStatus {
  BkgID: number;
  ServiceID: number;
  OptionID: number;
  Status: 'OK' | 'KO'
  StatusMessage: string;
}

export interface IResApiGetReplaceOptionsHistoryParams {
  BkgID?: number;
  ServiceID_OLD?: number;
  OptionID_OLD?: number;
  ServiceID_NEW?: number;
  OptionID_NEW?: number;
  DateFrom?: DateTime;
  DateTo?: DateTime;
  Status?: 'OK' | 'KO';
}

export class ResReplaceHistory extends SafeBaseObject {
  iD: number = 0;
  [key: string]: any;

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }
  override updateData(data: any): void {
    this.addMangledProperty(data);
  }
}






export class ReservationGetAllocations extends SafeBaseObject {
  serviceID = 0;
  optionID = 0;
  date = DateTime.invalid('empty');
  initialAllotmentQTY = 0;
  onHoldAllotmentQTY = 0;
  serviceName = '';
  optionName = '';
  packageNames = ''
  packageTravelDateID = 0;
  eRESAllocationCode = ''
  eRESAgencyCod = ''
  eRESRateCode = ''

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }
  override updateData(data: any): void {
    this.addMangledProperty(data);
    this.addDateTimeProperty('date', data, 'Date');
    if (data.PackageNames) {
      this.packageNames = data.PackageNames.replace(/\|/g, '\n');
    }
  }
}



export class ReservationOptionPriceAllocation extends SafeBaseObject {
  packageID = 0;
  packageName = '';
  packageTravelDateID = 0;
  travelStartDate = DateTime.invalid('empty');
  date = DateTime.invalid('empty');
  dateFrom = DateTime.invalid('empty');
  dateTo = DateTime.invalid('empty');
  initialAllotmentQTY = 0;
  onHoldAllotmentQTY = 0;
  allocationbyOptionIDs = '';
  canEdit = false;
  canDelete = false;
  travelDateStatus = '';
  eRESAgencyCod?: string;
  eRESAllocationCode?: string;
  eRESRateCode?: string;
  usedQuantity = 0;
  usedQuantityBySpl = 0;

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }
}

export class ReservationOptPkgPriceAllocation extends SafeBaseObject {
  key = ''
  packageTravelDateID = 0
  packageID = 0
  itineraryDate = DateTime.invalid('empty')
  childTag = ''
  serviceID = 0
  initialAllotmentQTY = 0
  onHoldAllotmentQTY = 0
  allocationbyOptionID = 0
  allocatedOnOtherPkg = 0
  soldOnPackage = 0
  minAvl = 0
  availabilityInitialQTY = 0
  availabilityOnHoldQTY = 0
  availabilitybyOptionID = 0
  eRES_AllocationCode = ''
  eRES_AgencyCod = ''
  eRES_RateCode = ''

  isSelected = false
  availabilityInitialQTYEditByUser = false
  originalValue = {
    initialAllotmentQTY: 0,
    availabilityInitialQTY: 0,
    eRES_AllocationCode: '',
    eRES_AgencyCod: '',
    eRES_RateCode: '',
  }

  get alertAvailability() {
    return this.availabilityInitialQTY < this.initialAllotmentQTY + this.allocatedOnOtherPkg
  }
  get initialAvailableQTYChanged() {
    return this.availabilityInitialQTY !== this.originalValue.availabilityInitialQTY
  }
  get initialAllotmentQTYChanged() {
    return this.initialAllotmentQTY !== this.originalValue.initialAllotmentQTY
  }
  get eRES_AllocationCodeChanged() {
    return this.eRES_AllocationCode !== this.originalValue.eRES_AllocationCode
  }
  get eRES_AgencyCodChanged() {
    return this.eRES_AgencyCod !== this.originalValue.eRES_AgencyCod
  }
  get eRES_RateCodeChanged() {
    return this.eRES_RateCode !== this.originalValue.eRES_RateCode
  }
  constructor(data?: any) {
    super();
    this.updateData(data);
  }
  override updateData(data?: any) {
    if (!data) return
    super.updateData(data)
    this.key = `${this.packageTravelDateID}-${this.itineraryDate.toISO()}`
    this.originalValue = {
      initialAllotmentQTY: this.initialAllotmentQTY,
      availabilityInitialQTY: this.availabilityInitialQTY,
      eRES_AllocationCode: this.eRES_AllocationCode,
      eRES_AgencyCod: this.eRES_AgencyCod,
      eRES_RateCode: this.eRES_RateCode,
    }
  }
}
export class ReservationOptionPriceDayByDay extends SafeBaseObject {
  pricePerDateID = 0;
  priceTypeID = 0;
  priceTypeName = '';
  priceSetUp = '';
  priceSetUpID = 0;
  dateFrom = DateTime.invalid('empty');
  dateTo = DateTime.invalid('empty');
  startDate = DateTime.invalid('empty');
  endDate = DateTime.invalid('empty');
  sellingPrice = 0;
  currency = '';
  roe?: number;
  margin?: number;
  startingCost = 0;
  startingCurrency = '';

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }

}

export class ReservationOptionPriceAllocationDetail extends SafeBaseObject {
  packageID = 0;
  packageName = '';
  date = DateTime.invalid('empty');
  initialAllotmentQTY = 0;
  onHoldAllotmentQTY = 0;
  allocationbyOptionID = 0;
  checked?: boolean;
  canEdit?: boolean;
  canDelete?: boolean;
  eRESAllocationCode?: string;
  eRESAgencyCod?: string;
  eRESRateCode?: string;
  packageTravelDateID?: number;

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }
}

export class ReservationOptionCostPerPax extends SafeBaseObject {
  optionCostPerPaxID = 0;
  serviceID = 0;
  serviceName = '';
  optionID = 0;
  optionName = '';
  startDate = DateTime.invalid('empty');
  endDate = DateTime.invalid('empty');
  dateFrom = DateTime.invalid('empty');
  dateTo = DateTime.invalid('empty');
  priceSetupID = 0;
  bedType?: string;
  mealPlan?: string;
  costSource?: string;
  cost = 0;
  currency = '';
  guestFrom = 0;
  guestTo = 0;
  status: string = 'A';

  cityTax?: number;
  includeCityTax?: boolean;
  type?: string;
  priceSetupIDCS?: number;
  vat?: number;
  includeVAT?: boolean;
  serviceTax?: number;
  includeServiceTax?: boolean;
  serviceTaxType?: string;
  serviceTaxSetup?: number;

  agencyGroupCod?: string;
  rateCode?: string;
  dayFrom: number = 1;
  dayTo: number = 99;

  hasCostBreakdown: boolean = false;

  details: { guestFrom: number, guestTo: number, cost: number, currency?: string, dateFrom: DateTime, dateTo: DateTime, indexDetail: number }[] = [];
  isEstimated = false;

  priceTypeID?: number;
  priceTypeName?: string;

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
    if (data?.VAT || data?.vat) this.vat = data.VAT ?? data.vat;
    if ((this.cityTax ?? 0) > 0 || (this.vat ?? 0) > 0 || (this.serviceTax ?? 0) > 0) this.hasCostBreakdown = true;
    this.includeCityTax = (data.IncludeCityTax == 'Y') || data.includeCityTax;
    this.includeVAT = (data.IncludeVAT == 'Y') || data.includeVAT;
    this.includeServiceTax = (data.IncludeServiceTax == 'Y') || data.includeServiceTax;
  }

  get isEstimatedDisplay() {
    if (this.cost >= 0 && !this.isEstimated) return 'Real Cost';
    return 'Estimated Cost';
  }
}

export class ReservationOptionCostPkg extends ReservationOptionCostPerPax {
  packageTypeID = 0;
  constructor(data?: any) {
    super(data);
  }
}

export interface IReservationApiManageBandCost {
  ServiceID: number;
  OptionID: number;
  OptionCostPerPax: IReservationOptionCostPerPax[]
}

export interface IReservationApiManageHolidayMarkup {
  HolidayMarkup: IReservationOptionCostHolidayMarkup[]
}

export interface IReservationApiManageCostPerDayChild {
  CostChild: IReservationOptionCostPerDayChild[]
}

export interface IReservationOptionCostPerPax {
  OptionCostPerPaxSGJID?: number;
  ServiceID?: number;
  OptionID?: number;
  Cost?: number;
  Currency?: string;
  GuestFrom?: number;
  GuestTo?: number;
  StartDate?: DateTime;
  EndDate?: DateTime;
  DateFrom?: DateTime;
  DateTo?: DateTime;
  Status?: string;
  CityTax?: number,
  IncludeCityTax?: 'Y' | 'N',
  Type?: string,
  PriceSetupIDCS?: number,
  VAT?: number,
  IncludeVAT?: 'Y' | 'N',
  ServiceTax?: number,
  IncludeServiceTax?: 'Y' | 'N',
  ServiceTaxType?: string,
  ServiceTaxSetup?: number,
  PriceTypeID?: number,
  AgencyGroupCod?: string | null,
  RateCode?: string
}

export interface IReservationOptionCostPkg extends IReservationOptionCostPerPax {
  PackageTypeID?: number;
}

export interface IReservationOptionCostHolidayMarkup {
  OptionCostHolidayMarkupID?: number;
  ServiceID?: number;
  OptionID?: number;
  StartDate?: DateTime;
  EndDate?: DateTime;
  DateFrom?: DateTime;
  DateTo?: DateTime;
  Currency?: string;
  ChildAgeFrom?: number;
  ChildAgeTo?: number;
  Type?: string;
  Amount?: number;
  Status?: string;
}

export interface IReservationOptionCostPerDayChild {
  OptionCostPerDayChildID?: number;
  ServiceID?: number;
  OptionID?: number;
  StartDate?: DateTime;
  EndDate?: DateTime;
  DateFrom?: DateTime;
  DateTo?: DateTime;
  Currency?: string;
  ChildNumFrom?: number;
  ChildNumTo?: number;
  ChildNumberFrom?: number;
  ChildNumberTo?: number;
  ChildAgeFrom?: number;
  ChildAgeTo?: number;
  Type?: string;
  Amount?: number;
  CityTax?: number,
  IncludeCityTax?: 'Y' | 'N',
  CityTaxType?: string,
  PriceSetupIDCS?: number,
  VAT?: number,
  IncludeVAT?: 'Y' | 'N',
  ServiceTax?: number,
  IncludeServiceTax?: 'Y' | 'N',
  ServiceTaxType?: string,
  ServiceTaxSetup?: number,
  Status?: string;
}

export class ReservationOptionCostHolidayMarkup extends SafeBaseObject {
  optionCostHolidayMarkupID = 0;
  serviceID = 0;
  optionID = 0;
  startDate = DateTime.invalid('empty');
  endDate = DateTime.invalid('empty');
  dateFrom = DateTime.invalid('empty');
  dateTo = DateTime.invalid('empty');
  currency = '';
  childAgeFrom = 0;
  childAgeTo = 0;
  type = 'Fixed';
  amount = 0;
  status = 'A';

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }
}

export class ReservationOptionCostPerDayChild extends SafeBaseObject {
  optionCostPerDayChildID = 0;
  serviceID = 0;
  optionID = 0;
  startDate = DateTime.invalid('empty');
  endDate = DateTime.invalid('empty');
  dateFrom = DateTime.invalid('empty');
  dateTo = DateTime.invalid('empty');
  priceSetupID = 0;
  bedType?: string;
  mealPlan?: string;
  costSource?: string;
  currency = '';
  childNumFrom = 0;
  childNumTo = 0;
  childNumberFrom = 0;
  childNumberTo = 0;
  childAgeFrom = 0;
  childAgeTo = 0;
  type = 'Fixed';
  amount = 0;
  status = 'A';

  cityTax?: number;
  includeCityTax?: boolean;
  cityTaxType?: string;
  priceSetupIDCS?: number;
  vat?: number;
  includeVAT?: boolean;
  serviceTax?: number;
  includeServiceTax?: boolean;
  serviceTaxType?: string;
  serviceTaxSetup?: number;

  hasCostBreakdown: boolean = false;

  agencyGroupCod?: string;
  rateCode?: string;
  isEstimated = false;

  dayFrom: number = 1;
  dayTo: number = 99;

  priceTypeID?: number;
  priceTypeName?: string;
  constructor(data?: any) {
    super();
    if (data) this.updateData(data);

    if (data?.VAT || data?.vat) this.vat = data.VAT ?? data.vat;
    if ((this.cityTax ?? 0) > 0 || (this.vat ?? 0) > 0 || (this.serviceTax ?? 0) > 0) this.hasCostBreakdown = true;
    this.includeCityTax = (data.IncludeCityTax == 'Y') || data.includeCityTax;
    this.includeVAT = (data.IncludeVAT == 'Y') || data.includeVAT;
    this.includeServiceTax = (data.IncludeServiceTax == 'Y') || data.includeServiceTax;
  }
  get isEstimatedDisplay() {
    if (this.amount >= 0 && !this.isEstimated) return 'Real Cost';
    return 'Estimated Cost';
  }
}

export interface IReservationApiGetCostCopy {
  Year?: number;
  ServiceTypeID?: number;
  ServiceGroupID?: number;
  ServiceName?: string;
  OptionName?: string;
  ServiceID?: number;
  OptionID?: number;
}

export interface IReservationApiManageCostCopy {
  Cost: IReservationCostCopyRow[];
  ServiceID?: number;
  OptionID?: number;
}
export interface IReservationApiManageBandCostCopy {
  Cost: IReservationBandCostCopyRow[];
  ServiceID?: number;
  OptionID?: number;
}

export interface IReservationApiManageCostChildCopy {
  Cost: IReservationCostChildCopyRow[];
  ServiceID?: number;
  OptionID?: number;
}

export interface IReservationCostCopyRow {
  OptionCostPerDayID?: number;
  ServiceID?: number;
  OptionID?: number;
  DateFrom?: DateTime;
  DateTo?: DateTime;
  BedType?: string;
  MealPlan?: string;
  CostDesc?: string;
  PriceSetup?: string;
  Cost?: number;
  Currency?: string;
  IsEstimated?: string;
}

export interface IReservationBandCostCopyRow {
  OptionCostPerPaxID?: number;
  ServiceID?: number;
  OptionID?: number;
  DateFrom?: DateTime;
  DateTo?: DateTime;
  BedType?: string;
  MealPlan?: string;
  CostSource?: string;
  PriceSetupID?: string;
  Cost?: number;
  Currency?: string;
  IsEstimated?: string;
  AgencyGroupCod?: string;
  RateCode?: string;
  GuestFrom?: number;
  GuestTo?: number;
  DayFrom?: number;
  DayTo?: number;
}

export interface IReservationCostChildCopyRow {
  OptionCostPerDayChildID?: number;
  ServiceID?: number;
  OptionID?: number;
  DateFrom?: DateTime;
  DateTo?: DateTime;
  BedType?: string;
  MealPlan?: string;
  CostSource?: string;
  PriceSetupID?: string;
  Amount?: number;
  Currency?: string;
  IsEstimated?: string;
  AgencyGroupCod?: string;
  RateCode?: string;
  GuestFrom?: number;
  GuestTo?: number;
  DayFrom?: number;
  DayTo?: number;
  ChildNumberFrom?: number,
  ChildNumberTo?: number,
  ChildAgeFrom?: number,
  ChildAgeTo?: number,
}

export class ReservationCostCopyService extends SafeBaseObject {
  serviceID = 0;
  optionID = 0;
  serviceType = '';
  serviceName = '';
  optionName = '';

  isSelected = false;
  periodsLoaded = false;
  periods: ReservationCostCopyPeriod[] = [];

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }
}

export class ReservationCostCopyPeriod extends SafeBaseObject {
  optionCostPerDayID = 0;
  optionCostPerPaxID = 0;
  serviceID = 0;
  optionID = 0;
  dateFrom = DateTime.invalid('empty');
  dateTo = DateTime.invalid('empty');
  bedType = '';
  mealPlan = '';
  bedDesc = '';
  mealDesc = '';
  costDesc = '';
  priceSetup = '';
  agencyGroupCod?: string;
  agencyGroupDesc?: string;
  costPriceType?: string;
  priceTypeID?: number;
  cost = 0;
  currency = '';
  isEstimated = false;

  isSelected = false;

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
    if (data.PriceTypeID) this.costPriceType = data.PriceTypeID;
  }
}

export class ReservationBandCostCopyService extends SafeBaseObject {
  serviceID = 0;
  optionID = 0;
  serviceType = '';
  serviceName = '';
  optionName = '';

  isSelected = false;
  periodsLoaded = false;
  periods: ReservationBandCostCopyPeriod[] = [];

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }
}

export class ReservationBandCostCopyPeriod extends SafeBaseObject {
  optionCostPerPaxID = 0;
  serviceID = 0;
  optionID = 0;
  guestFrom = 0;
  guestTo = 0;
  dayFrom = 0;
  dayTo = 0;
  dateFrom = DateTime.invalid('empty');
  dateTo = DateTime.invalid('empty');
  bedType = '';
  bedDesc = '';
  mealPlan = '';
  mealDesc = '';
  priceSetup = '';
  priceSetupID = 0;
  agencyGroupCod?: string;
  agencyGroupDesc?: string;
  rateCode?: string;
  cost = 0;
  costDesc = '';
  costSource = "";
  currency = '';
  isEstimated = false;

  isSelected = false;

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }
}

export class ResPriceSetupBookingList extends SafeBaseObject {
  packageID = 0;
  packageTravelDateID = 0;
  travelStartDate = DateTime.invalid('empty');
  travelEndDate = DateTime.invalid('empty');
  bkgID = 0;
  ownerType = '';
  agencyCod = '';
  agency = '';
  bkgStatus = '';
  directID = 0;
  guests = '';
  passportNumber = '';
  passportIssuePlace = '';
  passportIssueDate = DateTime.invalid('empty');
  passportExpireDate = DateTime.invalid('empty');
  chkAirDet = false;
  suiteNO = '';
  hasPreference = false;
  packageName = '';
  companyName = '';

  itemStatus = '';
  date = DateTime.invalid('empty');
  serviceName = '';
  optionName = '';

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }
}

export interface IResApiGetPriceSetupBookingListParams {
  PackageID?: number;
  PackageTravelDateID?: number;
  BkgStatus?: string;
  ServiceID?: number;
  OptionID?: number;
  DateFrom?: DateTime;
  DateTo?: DateTime;
  Type?: string;
  Src?: string;
  IsFromLimitedSetup?: string;
}

export class ResPackageClearingCruise extends SafeBaseObject {
  packageTypeName: string = '';
  packageID: number = 0;
  packageName: string = '';
  bkgID: number = 0;
  bkgStatus: string = '';
  guestNum: number = 0;
  passengerClass: string = '';
  suiteCategory: string = '';
  suiteCapacity: string = '';
  embarkDate = DateTime.invalid('empty');
  debarkDate = DateTime.invalid('empty');
  travelDateAvailabilityStatus: string = '';
  internalNotes: string = '';
  suiteAvl: number = 0;

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }
}

export class ResPackageClearingNoCruise extends SafeBaseObject {
  packageTypeName: string = '';
  packageID: number = 0;
  packageName: string = '';
  bkgID: number = 0;
  bkgStatus: string = '';
  guestNum: number = 0;
  travelStartDate = DateTime.invalid('empty');
  travelEndDate = DateTime.invalid('empty');
  travelDateAvailabilityStatus: string = '';
  internalNotes: string = '';
  onHoldQTYSingle: number = 0;
  onHoldQTYDouble: number = 0;


  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }
}

export class ResPackageClearingVoyage extends SafeBaseObject {
  voyageNumber: string = '';
  embarkDate = DateTime.invalid('empty');
  embarkCity: string = '';
  debarkDate = DateTime.invalid('empty');
  debarkCity: string = '';
  bkgID: number = 0;
  bkgStatus: string = '';
  guestNum: number = 0;
  passengerClass: string = '';
  suiteCategory: string = '';
  suiteCapacity: string = '';
  suiteAvl: number = 0;

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }
}

export class ResSanctuaryCampAllocationDetail extends SafeBaseObject {
  actualDate = DateTime.invalid('empty');
  actualYear: number = 0;
  actualMonth: number = 0;
  propertyLocation: string = '';
  property: string = '';
  roomCategory: string = '';
  roomCategoryID: number = 0;
  allocationID: number = 0;
  inventoryID: number = 0;
  noOfUnits: number = 0;
  allocation: number = 0;
  available: number = 0;
  propertyID: number = 0;
  modifiedDateTime = DateTime.invalid('empty');
  allocationPeriodID: number = 0;
  allocationCode: string = '';
  rateCodeID: number = 0;
  rateCode: string = '';
  rateCodeName: string = '';
  agentCode: string = '';
  agency: string = '';

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }
}

export interface IReservationApiGetSanctuaryCampAllocations {
  PropertyLocation?: string;
  PropertyID?: number;
  SuiteCategoryCod?: string;
  ActualDateFrom?: DateTime;
  ActualDateTo?: DateTime;
  ActualYear?: number;
  ActualMonth?: number;
  AllocationCode?: string;
  RateCode?: string;
  RateCodeName?: string;
  AgencyCode?: string;
  Page?: number;
  PageSize?: number;
}

export class ResSanctuaryCampAllocation extends SafeBaseObject {
  sanctuaryCampAllocationID: number = 0;
  propertyLocation: string = '';
  property: string = '';
  actualDate = DateTime.invalid('empty');
  actualYear: number = 0;
  actualMonth: number = 0;
  propertyID: number = 0;
  roomCategory: string = '';
  roomCategoryID: number = 0;
  inventoryID: number = 0;
  code: string = '';
  PMSCode: string = '';
  units: number = 0;
  booked: number = 0;
  available: number = 0;
  resStatus: number = 0;
  details: ResSanctuaryCampAllocationDetail[] = [];

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
    if (data?.Details?.length > 0) this.details = data.Details.map((detail: any) => new ResSanctuaryCampAllocationDetail(detail));
  }

}
export class ResSanctuaryCampSuiteCategory extends SafeBaseObject {
  propertyID: number = 0;
  property: string = '';
  propertyCode: string = '';
  suiteCategoryID: number = 0;
  suiteCategory: string = '';
  suiteCategoryCod: string = '';
  shipID: number = 0;

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }
}
export class ResSanctuaryCampAgency extends SafeBaseObject {
  agentID: number = 0;
  agency: string = '';
  agencyCode: string = '';

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }
}
export class ResPkgEResAllocation extends SafeBaseObject {
  allocationByOptionID = 0
  packageID = 0
  packageTravelDateID = 0
  travelStartDate = DateTime.invalid('empty')
  travelEndDate = DateTime.invalid('empty')
  packageName = ''
  serviceTypeID = 0
  serviceTypeName = ''
  serviceID = 0
  serviceLongName = ''
  optionID = 0
  optionName = ''
  day = 0
  date = DateTime.invalid('empty')
  ship = ''
  propertyID = 0
  suiteCategoryCod = ''
  totalAvailability = 0
  initialAllotmentQTY = 0
  onHoldAllotmentQTY = 0
  allocOnOtherPackages = 0
  eRES_AllocationCode = ''
  eRES_RateCode = ''
  eRES_AgencyCod = ''
  dateFrom = DateTime.invalid('empty')
  dateTo = DateTime.invalid('empty')
  code = ''
  allocation = 0
  available = 0
  suiteCode = ''
  rateCode = ''
  rateCodeName = ''
  agentCode = ''
  cntMatchingAllCode = 0
  oneIs2EresMatching = ''
  potentialOneIs2EresMatching = ''

  isSelected = false
  originalValue = {
    totalAvailability: 0,
    initialAllotmentQTY: 0,
    onHoldAllotmentQTY: 0,
    allocOnOtherPackages: 0,
    eRES_AllocationCode: '',
    eRES_AgencyCod: '',
    eRES_RateCode: '',
  }
  get totalAvailabilityChanged() {
    return this.totalAvailability !== this.originalValue.totalAvailability
  }
  get onHoldAllotmentQTYChanged() {
    return this.onHoldAllotmentQTY !== this.originalValue.onHoldAllotmentQTY
  }
  get initialAllotmentQTYChanged() {
    return this.initialAllotmentQTY !== this.originalValue.initialAllotmentQTY
  }
  get eRES_AllocationCodeChanged() {
    return this.eRES_AllocationCode !== this.originalValue.eRES_AllocationCode
  }
  get eRES_AgencyCodChanged() {
    return this.eRES_AgencyCod !== this.originalValue.eRES_AgencyCod
  }
  get eRES_RateCodeChanged() {
    return this.eRES_RateCode !== this.originalValue.eRES_RateCode
  }
  get dataEResChanged() {
    return this.onHoldAllotmentQTYChanged
      || this.initialAllotmentQTYChanged
      || this.eRES_AllocationCodeChanged
      || this.eRES_AgencyCodChanged
      || this.eRES_RateCodeChanged
  }
  get hasInitialAllotmentQTYError() {
    const minAllowed = (this.originalValue.initialAllotmentQTY ?? 0) - (this.originalValue.onHoldAllotmentQTY ?? 0)
    return (this.initialAllotmentQTY ?? 0) < 0 || (this.initialAllotmentQTY ?? 0) < minAllowed
  }
  get hasAllocationError() {
    const minAllowed = (this.originalValue.initialAllotmentQTY ?? 0) - (this.originalValue.onHoldAllotmentQTY ?? 0)
    return this.allocation != 0 && ((this.allocation ?? 0) < 0 || (this.allocation ?? 0) < minAllowed)
  }
  get hasOnHoldAllotmentQTYError() {
    return (this.onHoldAllotmentQTY ?? 0) < 0
  }
  get hasValidationError() {
    return this.hasInitialAllotmentQTYError || this.hasOnHoldAllotmentQTYError
  }
  constructor(data?: any) {
    super();
    this.updateData(data);
  }
  override updateData(data?: any) {
    if (!data) return
    super.updateData(data)
    this.originalValue = {
      totalAvailability: this.totalAvailability,
      initialAllotmentQTY: this.initialAllotmentQTY,
      onHoldAllotmentQTY: this.onHoldAllotmentQTY,
      allocOnOtherPackages: this.allocOnOtherPackages,
      eRES_AllocationCode: this.eRES_AllocationCode,
      eRES_AgencyCod: this.eRES_AgencyCod,
      eRES_RateCode: this.eRES_RateCode,
    }
  }
}

export interface IReservationApiManageSgjCost {
  ServiceID: number;
  OptionID: number;
  PackageTypeID?: number;
  OptionCostPerPax: IReservationOptionCostPerPax[]
}

export class ResCostPriceType extends SafeBaseObject {
  priceTypeID: number = 0;
  priceTypeName: string = '';
  priceTypeCod: string = '';
  currency: string = '';

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }
}

export class ReservationOptionPricePerBand extends SafeBaseObject {
  pricePerBandID = 0;
  serviceID = 0;
  optionID = 0;
  startDate = DateTime.invalid('empty');
  endDate = DateTime.invalid('empty');
  dateFrom = DateTime.invalid('empty');
  dateTo = DateTime.invalid('empty');
  guestFrom = 0;
  guestTo = 0;
  dayFrom: number = 1;
  dayTo: number = 99;
  bedType?: string;
  mealPlan?: string;
  sellingPrice: number = 0;
  sellingTax: number = 0;
  priceTypeID?: number;
  priceTypeName?: string;
  agencyGroupCod?: string;
  rateCode?: string;
  currency = '';
  rOE: number = 0;
  margin: number = 0;
  costPriceTypeID?: number;
  costPriceTypeName?: string;

  startingCost: number = 0;
  startingCurrency: string = "";
  snglSuppType: string = "";
  snglSuppValue: number = 0;
  snglSuppCommPerc: number = 0;
  status: string = 'A';


  costSource?: string;
  priceSetupID = 0;

  cityTax?: number;
  includeCityTax?: boolean;
  type?: string;
  priceSetupIDCS?: number;
  vat?: number;
  includeVAT?: boolean;
  serviceTax?: number;
  includeServiceTax?: boolean;
  serviceTaxType?: string;
  serviceTaxSetup?: number;

  hasCostBreakdown: boolean = false;

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
    if (data?.VAT || data?.vat) this.vat = data.VAT ?? data.vat;
    if ((this.cityTax ?? 0) > 0 || (this.vat ?? 0) > 0 || (this.serviceTax ?? 0) > 0) this.hasCostBreakdown = true;
    this.includeCityTax = (data.IncludeCityTax == 'Y') || data.includeCityTax;
    this.includeVAT = (data.IncludeVAT == 'Y') || data.includeVAT;
    this.includeServiceTax = (data.IncludeServiceTax == 'Y') || data.includeServiceTax;
  }
}

export class ReservationOptionPricePerChild extends ReservationOptionPricePerBand {
  childNumFrom = 0;
  childNumTo = 0;
  childNumberFrom = 0;
  childNumberTo = 0;
  childAgeFrom = 0;
  childAgeTo = 0;
  constructor(data?: any) {
    super(data);
  }
}
export class ReservationOptionPricePerCost extends ReservationOptionPricePerBand {
  constructor(data?: any) {
    super(data);
  }
}
